/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicSiteFilterKey } from './PublicSiteFilterKey';
import type { PublicSitePropertySort } from './PublicSitePropertySort';
export type PublicSiteSearchCapabilities = {
    pagination: PublicSiteSearchCapabilities.pagination;
    filters: Array<PublicSiteFilterKey>;
    sorts: Array<PublicSitePropertySort>;
    maxSize: number;
    supportsTotalCount?: boolean;
};
export namespace PublicSiteSearchCapabilities {
    export enum pagination {
        CURSOR = 'cursor',
    }
}

